import React from 'react';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppMeterGroupsService from '../../AppMeterGroupsService';

//hooks
import { useRouter } from '../../../../shared/hooks/useRouter';

//global component
import ModalButton from '../../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
} from '../../../../SharedStyles';

const DeleteModal = (props) => {
  const { strings } = AppMeterGroupsService;
  const { handleCloseModal, meterGroup, handleDeleting } = props;
  const router = useRouter();

  const closeModal = () => {
    handleCloseModal();
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    handleDeleting(meterGroup.meterGroupId);
    if (router.match.params.id) {
      router.history.push('/meter-groups');
    }
    handleCloseModal();
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.deleteModalTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles>
            {meterGroup.chargerCount > 0 && (
              <p>
                {strings.deleteModalContentOne}{' '}
                {strings.deleteModalContentCharger} ({meterGroup.chargerCount}){' '}
                {strings.deleteModalContentTwo}
              </p>
            )}
          </ModalItemStyles>
          {/* Section */}
          <ModalItemStyles>
            {meterGroup.chargerCount === 0 && (
              <p>{strings.deleteModalContentOne}</p>
            )}
          </ModalItemStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          handleClick={handleSaveInfo}
          buttonText={strings.deleteModalButton}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default DeleteModal;
